<script>
import entreprise from '../../../assets/icons/ic-entreprise.svg'
import ic_enterprise from "@/assets/icons/ic_society-small.svg";
import { updateService } from "@/component/cdevs/allFunctions";

export default {
  name: 'ModifsServicePopup',
  components: {},
  props: {
    showPopup2: {
      type: Boolean,
      required: true,
    },
    selectedService: {
      type: Object,
      default: () => ({})
    },
      serviceId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icons: { entreprise, ic_enterprise },
      name: this.selectedService.title || '',
      description: this.selectedService.description || '',
      email: this.selectedService.ownersEmail ? this.selectedService.ownersEmail[0] : ''
    };
  },
  watch: {
    selectedService: {
      immediate: true,
      handler(newVal) {
        this.name = newVal.title || '';
        this.description = newVal.description || '';
        this.email = newVal.ownersEmail ? newVal.ownersEmail[0] : '';
      }
    }
  },
  
  emit: ['closeCreate', 'refresh'],

  methods: {
    closeCreate() {
      this.$emit('closeCreate');
    },

    async updateService() {
        console.log('serviceId:', this.serviceId); // Ajoute ce log

      if (this.name === '' || this.description === '' || this.email === '') {
        return this.$toast.error('Veuillez remplir tous les champs')
      }
      this.charge = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        title: this.name,
        description: this.description,
        ownersEmail: [this.email],
        id: this.serviceId
      }
      await updateService(data).then(response => {
        console.log(response)
        this.charge = false;
        this.$toast.success('Service modifié avec succès');
        this.$emit('refresh');
        this.$emit('closeCreate', true);
      }).catch(error => {
        console.log(error)
        this.charge = false;
        this.$toast.error('Une erreur est survenue');
      })
    },
  }
}
</script>

<template>
  <div class="popup-overlay">
    <div class="popup-content bg-white w-1/3 py-5 relative">
      <div class="flex font-c7 text-c22 colorBorderB pb-5 px-5">
        Modification du service
      </div>
      <div class="mt-5">
        <div class="font-c4 text-base mx-5">
          <div class="mb-2 text-left text-82">
            Nom du service
          </div>
          <div class="input-bloc relative">
            <input
              v-model="name"
              type="text"
              class="h-14 bgInpout w-full rounded-10 pl-5"
              placeholder="Ex: Crédit croissance PME"
            >
          </div>
        </div>
        <div class="font-c4 text-base mx-5 my-5">
          <div class="mb-2 text-left text-82">
            Description du service
          </div>
          <div class="input-bloc relative">
            <textarea
              v-model="description"
              class="h-40 bgInpout w-full rounded-10 pl-5 py-2"
              placeholder="Ex: Crédit croissance PME"
            />
          </div>
        </div>
        <div class="font-c4 text-base mx-5">
          <div class="mb-2 text-left text-82">
            Email de redirection
          </div>
          <div class="input-bloc relative">
            <input
              v-model="email"
              type="email"
              class="h-14 bgInpout w-full rounded-10 pl-5"
              placeholder="notification@cci.bj"
            >
          </div>
        </div>
        <div class="flex justify-end items-center mt-5 mx-5">
          <div
            class="font-c5 text-red-500 mt-2 text-sm ml-5 cursor-pointer annulerr px-7 py-3 rounded-8"
            @click="closeCreate"
          >
            Annuler
          </div>
          <div
            class="text-red-500 mt-2 text-sm ml-5 cursor-pointer save px-10 py-3 rounded-8 text-white"
            @click="updateService()"
          >
            Modifier
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.annulerr{
    background-color: #EFF4FB;
}
.save{
    background-color: #241A72;
}
.colorBorderB{
    border-bottom: 3px solid #E7EEF8;
}
.bgInpout{
    border: 1px solid #F0F2F7;
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 25rem;
}
.relative {
  position: relative;
}
</style>
